import { Injectable } from '@angular/core';
import { GenericResponse } from 'projects/Autofacets-Core/src/app/business-entities/generic-response.class';
import { DFModel } from '../business-entities/df-model';
import {
  ApproveRejectAppointmentModal,
  EditWidgetVehicleDetail,
  WidgetAppointmentRequestModel
} from './../business-entities/widget-appointment-request-model';
import { WidgetDataService } from './../data-services/widget-data.service';

@Injectable({
  providedIn: 'root',
})
export class WidgetAppointmentService {
  widgetAppointment: any;
  widgetAppointmentRequest: WidgetAppointmentRequestModel = {
    userId: '',
    searchTerm: '',
    languageCode: '',
    startRecordNumber: 0,
    pageSize: 25,
    sortColumn: '',
    sortDirection: '',
    appointmentStatusId: 0,
    bookingDate: null,
    createdDate: null,
  };

  constructor(private service: WidgetDataService) { }

  async getWidgetAppointmentList(
    requestModel: WidgetAppointmentRequestModel
  ): Promise<GenericResponse<any>> {
    return this.service.getWidgetAppointmentList(requestModel);
  }

  async getWidgetAppointmentDetail(id: number, languageCode: string): Promise<GenericResponse<any>> {
    return this.service.GetWidgetAppointmentDetail(id, languageCode);
  }

  DeleteAppointment(id: any): Promise<any> {
    return this.service.DeleteAppointment(id);
  }

  async approveRejectWidgetAppointment(
    approverejectModal: ApproveRejectAppointmentModal
  ): Promise<any> {
    return this.service.ApproveRejectWidgetAppointment(approverejectModal);
  }
  async AddDFDetails(model: DFModel): Promise<any> {
    return this.service.AddDFDetails(model);
  }
  async getAppointmentStatusList(): Promise<any> {
    return this.service.getAppointmentStatusList();
  }

  async updateWidgetAppointmentVehicleDetail(model: EditWidgetVehicleDetail): Promise<any> {
    return this.service.updateWidgetAppointmentVehicleDetail(model);
  }
}
